import TableConfirmDetail from './TableConfirmDetail';

export default TableConfirmDetail;
